<template>
  <div>
    <component :is="currentScreen"/>
  </div>
</template>

<script>
  /*
  *     "steps" is an array of translations. Every element of array is an array of steps in certain language
  */
  import {
    EVENT_SET_SCENARIO,
    EVENT_GA_SEND,
    EVENT_PREV_STEP,
    EVENT_NEXT_STEP,
    EVENT_DEMO_LINK
  } from '@/constants';

  import {mapState} from 'vuex';
  import {mapActions} from 'vuex';

  import mainScreenX from './screens/main-screen-x';
  import reportsTreeScreenSc4St2_5 from './screens/reports-tree-screen-sc4-st2_5';
  import previewReportScreenSc4St6_10 from './screens/preview-report-screen-sc4-st6_10';
  import previewReportScreenSc4St11 from './screens/preview-report-screen-sc4-st11';

  export default {
    name: "folder-and-file-prm-screens",
    components: {
      mainScreenX,
      reportsTreeScreenSc4St2_5,
      previewReportScreenSc4St6_10,
      previewReportScreenSc4St11
    },
    data() {
      return {
        product: 'CRsuite',
        creationLeadRequired: true,
        steps: [
          [
            {
              tooltip: {
                position: 'left',
                align: 50,
                alignArrow: 50,

                text: '<p>All predefined and custom Netwrix Auditor reports are stored in one place. Let’s see what we have there.</p> <p>Click <b>View all</b> to continue.</p>',
                showSteps: true,
                actions: [],
              },
              viewArea: {
                x: 635,
                y: 445,
                width: 73,
                height: 28,
              },
              screen: 'main-screen-x',
            },
            {
              tooltip: {
                position: 'left',
                 text: '<p>The reports and dashboards are split into three high-level folders: Predefined, Compliance and Custom.</p> <p>Today, we’ll focus on the ready-to-use reports provided by Netwrix.</p> <p>Click <b>Next</b> to continue.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Back',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                  {
                    text: 'Next',
                    events: [
                      {
                        type: EVENT_NEXT_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 124,
                y: 102,
                width: 493,
                height: 631,
              },
              screen: 'reports-tree-screen-sc4-st-2_5',
            },
            {
              tooltip: {
                position: 'left',
                align: 50,
                alignArrow: 50,

                text: '<p>I’ve got an idea. Let me show you some reports on <b>file server permissions</b>. After all, IT admins have to work with access rights all the time to keep their environment secure and compliant.</p> <p>Click <b>File Servers</b> to continue.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Back',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 124,
                y: 412,
                width: 493,
                height: 35,
              },
              screen: 'reports-tree-screen-sc4-st-2_5',
            },
            {
              tooltip: {
                position: 'left',
                align: 50,
                alignArrow: 50,

                text: '<p>Here we’ve got activity reports and State-in-Time reports. Activity reports answer the question: what happened? State-in-Time reports, on the other hand, show us the configuration state at a specific moment in time.</p> <p>We’ve already looked at one activity report, so now let’s do a State-in-Time report.</p> <p>Click <b>File Servers – State-in-Time</b> to continue.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Back',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                scrollToView: true,
                x: 124,
                y: 476,
                width: 493,
                height: 35,
              },
              screen: 'reports-tree-screen-sc4-st-2_5',
            },
            {
              tooltip: {
                position: 'left',
                align: 50,
                alignArrow: 50,

                text: '<p>Here we’ve got activity reports and State-in-Time reports. Activity reports answer the question: what happened? State-in-Time reports, on the other hand, show us the configuration state at a specific moment in time.</p> <p>We’ve already looked at one activity report, so now let’s do a State-in-Time report.</p> <p>Now select <b>Folder and File Permission Details</b> to drill down into the report details.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Back',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 124,
                y: 667,
                width: 493,
                height: 35,
              },
              screen: 'reports-tree-screen-sc4-st-2_5',
            },
            {
              tooltip: {
                position: 'left',

                text: '<p>By default, this report shows the permissions that all accounts have to the root folder of a monitored share and its first-level subfolders.</p> <p>Scroll around and click <b>Next</b> when you’re ready to dive deeper.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Back',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                  {
                    text: 'Next',
                    events: [
                      {
                        type: EVENT_NEXT_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                scrollToView: true,
                x: 124,
                y: 680,
                width: 870,
                height: 780,
              },
              screen: 'preview-report-screen-sc4-st6_10',
            },
            {
              tooltip: {
                width: 370,
                position: 'left',
                align: 30,
                alignArrow: 20,

                text: '<p>Let’s imagine that we have a very sensitive folder and we need to ensure that only eligible people have access to it.</p> <p>Once again we’ll be using filters to solve this challenge.</p><p>Click <b>Next</b> when you’re ready to start.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Back',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                  {
                    text: 'Next',
                    id: 'sc4_st7',
                    events: [
                      {
                        type: EVENT_NEXT_STEP,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'File and Folders Permissions',
                          stage: '50%',
                        },
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                scrollToView: true,
                x: 114,
                y: 100,
                width: 960,
                height: 302,
              },
              screen: 'preview-report-screen-sc4-st6_10',
            },
            {
              tooltip: {
                position: 'left',
                align: -100,
                alignArrow: 15,

                text: '<p>First let’s specify which folder we want to review permissions for.</p><p>Type <b>\\\\fileserver1\\Shared\\Finance</b> in the Object UNC Path filter.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Back',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 594,
                y: 168,
                width: 480,
                height: 35,
              },
              screen: 'preview-report-screen-sc4-st6_10',
            },
            {
              tooltip: {
                position: 'left',
                align: -100,
                alignArrow: 15,

                text: '<p>Let’s also not expand the group membership. That will reduce the number of things we have to review and give us a higher level view of access permissions.</p><p>Select <b>No</b> in the Expand Group Membership filter.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Back',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 110,
                y: 300,
                width: 480,
                height: 35,
              },
              screen: 'preview-report-screen-sc4-st6_10',
            },
            {
              tooltip: {
                position: 'leftTRUE',
                align: -65,
                alignArrow: 21,
                width: 395,
                text: '<p>That looks great! Let’s run the report now.</p> <p>Click <b>View Report</b> to continue.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Back',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 1438,
                y: 130,
                width: 115,
                height: 50,
              },
              screen: 'preview-report-screen-sc4-st6_10',
            },
            {
              tooltip: {
                position: 'left',
                align: -30,
                alignArrow: 32,

                text: '<p>As you can see, there is one group and two users who have access to the Finance folder.</p> <p>The group is <b>Finance</b> — no questions there.</p><p>But why in the world do the user accounts <b>T.Smith</b> and <b>J.Roberts</b> have direct full control permissions over this folder?</p><p>Click <b>Next</b> to continue.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Back',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                  {
                    text: 'Next',
                    events: [
                      {
                        type: EVENT_NEXT_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                scrollToView: true,
                x: 124,
                y: 680,
                width: 870,
                height: 213,
              },
              screen: 'preview-report-screen-sc4-st11',
            },
            {
              tooltip: {
                position: 'left',
                align: -105,
                alignArrow: 80,

                text: '<p>It also looks like one of the subfolders, <b>Accounting</b>, has broken permissions inheritance — <b>T.Simpson</b> has full control over this folder, and it was granted directly. That’s a clear violation of permissions assignment best practices. </p><p>Click <b>Next</b> to continue.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Back',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                  {
                    text: 'Next',
                    events: [
                      {
                        type: EVENT_NEXT_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 124,
                y: 896,
                width: 870,
                height: 237,
              },
              screen: 'preview-report-screen-sc4-st11',
            },
            {
              tooltip: {
                position: 'left',
                align: -100,
                alignArrow: 17,
                width: 395,
                text: '<p>Great job! I sent you a copy of this report as well.</p><p>Click the <b>Back arrow</b> when you’re ready.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Back',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                scrollToView: true,
                x: 116,
                y: 38,
                width: 50,
                height: 38,
              },
              screen: 'preview-report-screen-sc4-st11',
            },
            {
              tooltip: {
                width: 424,
                hideViewArea: true,
                hideArrow: true,

                text: '<p>That’s it for this report. But I’m happy to show you some other useful things you can do with Netwrix Auditor; just click <b>Continue Tour.</b></p> <p>If you’re ready to set up a one-on-one demo with one of our engineers, though, I won’t be offended in the least! Just click <b>Request 1-1 Demo.</b></p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Continue Tour',
                    id: 'sc4_st14',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 0,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'File and Folders Permissions',
                          stage: 'Completed',
                        },
                      },
                    ],
                  },
                  {
                    text: 'Request 1-1 Demo',
                    events: [
                      {
                        type: EVENT_DEMO_LINK,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 1180,
                y: 400,
                width: 1,
                height: 1,
              },
              screen: 'main-screen-x',
            },
          ],
          [
            {
              tooltip: {
                position: 'left',
                align: 50,
                alignArrow: 50,

                text: '<p>Tous les rapports prédéfinis et personnalisés de Netwrix Auditor sont stockés au même endroit. Voyons ce que nous y trouvons.</p> <p>Cliquez sur <b>View all</b> pour continuer.</p>',
                showSteps: true,
                actions: [],
              },
              viewArea: {
                x: 635,
                y: 445,
                width: 73,
                height: 28,
              },
              screen: 'main-screen-x',
            },
            {
              tooltip: {
                position: 'left',
                width: 385,
                text: '<p>Les rapports et les tableaux de bord sont répartis dans trois dossiers de haut niveau : Predefined (Prédéfinis), Compliance (Conformité) and Custom (Personnalisés).</p> <p>Aujourd’hui, nous allons nous intéresser aux rapports prêts à l’emploi proposés par Netwrix.</p> <p>Cliquez sur <b>Suivant</b> pour continuer.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Précédent',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                  {
                    text: 'Suivant',
                    events: [
                      {
                        type: EVENT_NEXT_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 124,
                y: 102,
                width: 493,
                height: 631,
              },
              screen: 'reports-tree-screen-sc4-st-2_5',
            },
            {
              tooltip: {
                position: 'left',
                align: 50,
                alignArrow: 50,

                text: '<p>Maintenant, je vais vous présenter quelques rapports sur <b>les autorisations relatives aux serveurs de fichiers</b>. Après tout, les administrateurs informatiques gèrent en permanence les droits d’accès pour assurer la sécurité et la conformité de leur environnement.</p> <p>Cliquez sur <b>File Servers</b> (Serveurs de fichiers) pour continuer.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Précédent',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 124,
                y: 412,
                width: 493,
                height: 35,
              },
              screen: 'reports-tree-screen-sc4-st-2_5',
            },
            {
              tooltip: {
                position: 'left',
                align: 50,
                alignArrow: 50,

                text: '<p>Nous trouvons ici des rapports d’activité et des rapports State-in-Time. Les rapports d’activité répondent à la question : que s’est-il passé ? Les rapports State-in-Time, pour leur part, montrent l’état de la configuration à un moment précis dans le temps.</p> <p>Nous avons déjà examiné un rapport d’activité, alors voyons maintenant un rapport State-in-Time.</p> <p>Cliquez sur <b>File Servers – State-in-Time – Folder and File Permission Details</b> (Détails des autorisations pour les fichiers et dossiers) pour continuer.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Précédent',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                scrollToView: true,
                x: 124,
                y: 476,
                width: 493,
                height: 35,
              },
              screen: 'reports-tree-screen-sc4-st-2_5',
            },
            {
              tooltip: {
                position: 'left',
                align: 50,
                alignArrow: 50,

                text: '<p>Nous trouvons ici des rapports d’activité et des rapports State-in-Time. Les rapports d’activité répondent à la question : que s’est-il passé ? Les rapports State-in-Time, pour leur part, montrent l’état de la configuration à un moment précis dans le temps.</p> <p>Nous avons déjà examiné un rapport d’activité, alors voyons maintenant un rapport State-in-Time.</p> <p>Cliquez sur <b>File Servers – State-in-Time – Folder and File Permission Details</b> (Détails des autorisations pour les fichiers et dossiers) pour continuer.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Précédent',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 124,
                y: 667,
                width: 493,
                height: 35,
              },
              screen: 'reports-tree-screen-sc4-st-2_5',
            },
            {
              tooltip: {
                position: 'left',
                width: 385,
                text: '<p>Par défaut, ce rapport affiche les autorisations dont disposent tous les comptes pour le dossier racine d’un partage surveillé et ses sous-dossiers de premier niveau.</p> <p>Faites défiler et cliquez sur <b>Suivant</b> lorsque vous êtes prêt à explorer plus profondément.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Précédent',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                  {
                    text: 'Suivant',
                    events: [
                      {
                        type: EVENT_NEXT_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                scrollToView: true,
                x: 124,
                y: 680,
                width: 870,
                height: 780,
              },
              screen: 'preview-report-screen-sc4-st6_10',
            },
            {
              tooltip: {
                width: 370,
                position: 'left',
                align: 30,
                alignArrow: 20,

                text: '<p>Imaginons qu’un de nos dossiers soit très sensible et que nous devions faire en sorte que seules certaines personnes puissent y accéder.</p> <p>Encore une fois, nous allons utiliser des filtres pour résoudre ce problème.</p><p>Cliquez sur <b>Suivant</b> lorsque vous êtes prêt à commencer.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Précédent',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                  {
                    text: 'Suivant',
                    id: 'sc4_st7',
                    events: [
                      {
                        type: EVENT_NEXT_STEP,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'File and Folders Permissions',
                          stage: '50%',
                        },
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                scrollToView: true,
                x: 114,
                y: 100,
                width: 960,
                height: 302,
              },
              screen: 'preview-report-screen-sc4-st6_10',
            },
            {
              tooltip: {
                position: 'left',
                align: -100,
                alignArrow: 15,

                text: '<p>Commençons par spécifier le dossier dont nous voulons examiner les autorisations.</p><p>Saisissez <b>\\\\fileserver1\\Shared\\Finance</b> dans le filtre <br>« Object UNC Path » (Chemin d’accès UNC de l’objet).</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Précédent',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 594,
                y: 168,
                width: 480,
                height: 35,
              },
              screen: 'preview-report-screen-sc4-st6_10',
            },
            {
              tooltip: {
                position: 'left',
                align: -100,
                alignArrow: 15,

                text: '<p>Ne développons pas non plus l’appartenance aux groupes. Cela va réduire le nombre de points à examiner et cela nous permettra d’obtenir une vue de plus haut niveau sur les autorisations d’accès.</p><p>Sélectionnez <b>No</b> (Non) dans le filtre « Expand Group Membership » (Développer l’appartenance aux groupes).</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Précédent',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 110,
                y: 300,
                width: 480,
                height: 35,
              },
              screen: 'preview-report-screen-sc4-st6_10',
            },
            {
              tooltip: {
                position: 'leftTRUE',
                align: -65,
                alignArrow: 21,
                width: 395,
                text: '<p>Parfait ! Maintenant, exécutons le rapport.</p> <p>Cliquez sur <b>View Report</b> (Afficher le rapport) pour continuer.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Précédent',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 1438,
                y: 130,
                width: 115,
                height: 50,
              },
              screen: 'preview-report-screen-sc4-st6_10',
            },
            {
              tooltip: {
                position: 'left',
                align: -30,
                alignArrow: 32,
                width: 385,
                text: '<p>Comme vous pouvez le voir, un groupe et deux utilisateurs ont accès au dossier Finance.</p> <p>Le groupe est <b>Finance</b> – aucun doute là-dessus.</p><p>Mais pourquoi donc est-ce que les comptes d’utilisateur <b>T.Smith</b> et <b>J.Roberts</b> disposent d’autorisations directes pour un contrôle total de ce dossier ?</p><p>Cliquez sur <b>Suivant</b> pour continuer.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Précédent',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                  {
                    text: 'Suivant',
                    events: [
                      {
                        type: EVENT_NEXT_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                scrollToView: true,
                x: 124,
                y: 680,
                width: 870,
                height: 213,
              },
              screen: 'preview-report-screen-sc4-st11',
            },
            {
              tooltip: {
                position: 'left',
                align: -105,
                alignArrow: 80,
                width: 385,
                text: '<p>Il semble également que l’un des sous-dossiers, <b>Accounting</b> (Comptabilité), ait un héritage d’autorisation rompu – <b>T.Simpson</b> a les pleins pouvoirs sur ce dossier, et il a obtenu directement ces autorisations. Il s’agit là d’une violation flagrante des bonnes pratiques en matière d’attribution des autorisations.</p><p>Cliquez sur <b>Suivant</b> dès que vous êtes prêt.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Précédent',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                  {
                    text: 'Suivant',
                    events: [
                      {
                        type: EVENT_NEXT_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 124,
                y: 896,
                width: 870,
                height: 237,
              },
              screen: 'preview-report-screen-sc4-st11',
            },
            {
              tooltip: {
                position: 'left',
                align: -100,
                alignArrow: 17,
                width: 395,
                text: '<p>Cliquez sur la flèche de <b>retour</b> lorsque vous êtes prêt.</p>',
                showSteps: true,
                actions: [],
              },
              viewArea: {
                scrollToView: true,
                x: 116,
                y: 38,
                width: 50,
                height: 38,
              },
              screen: 'preview-report-screen-sc4-st11',
            },
            {
              tooltip: {
                width: 547,
                hideViewArea: true,
                hideArrow: true,

                text: '<p>Je serais ravi de vous montrer d’autres rapports ou d’autres choses utiles réalisables avec Netwrix Auditor ; il vous suffit de cliquer sur <b>Poursuivre la visite</b>.</p> <p>Si vous êtes prêt à planifier une démonstration personnalisée avec l’un de nos ingénieurs, cliquez sur <b>Demander une démo individuelle</b>.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Poursuivre la visite',
                    id: 'sc4_st14',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 0,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'File and Folders Permissions',
                          stage: 'Completed',
                        },
                      },
                    ],
                  },
                  {
                    text: 'Demander une démo individuelle',
                    events: [
                      {
                        type: EVENT_DEMO_LINK,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 1180,
                y: 400,
                width: 1,
                height: 1,
              },
              screen: 'main-screen-x',
            },
          ],
          [
            {
              tooltip: {
                position: 'left',
                align: 50,
                alignArrow: 50,

                text: '<p>Alle vordefinierten und benutzerdefinierten Berichte von Netwrix Auditor werden in einem zentralen Verzeichnis gespeichert. Sehen wir uns den Inhalt dieses Verzeichnisses einmal genauer an.</p> <p>Klicken Sie auf <b>View all</b>, um fortzufahren.</p>',
                showSteps: true,
                actions: [],
              },
              viewArea: {
                x: 635,
                y: 445,
                width: 73,
                height: 28,
              },
              screen: 'main-screen-x',
            },
            {
              tooltip: {
                position: 'left',
                text: '<p>Die Berichte und Dashboards sind in den drei Ordnern "Predefined", "Compliance" und "Custom" gespeichert.</p> <p>Heute geht es vor allem um die vordefinierten Berichte von Netwrix Auditor.</p> <p>Klicken Sie auf <b>Weiter</b>, um fortzufahren.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Zurück',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                  {
                    text: 'Weiter',
                    events: [
                      {
                        type: EVENT_NEXT_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 124,
                y: 102,
                width: 493,
                height: 631,
              },
              screen: 'reports-tree-screen-sc4-st-2_5',
            },
            {
              tooltip: {
                position: 'left',
                align: 50,
                alignArrow: 50,

                text: '<p>Ich möchte Ihnen nun einige Berichte zu den <b>Berechtigungen für Dateiserver</b> zeigen. Schließlich müssen IT-Administratoren die Zugriffsrechte jederzeit im Blick behalten, um die Sicherheit und Compliance der Umgebung zu gewährleisten.</p> <p>Klicken Sie auf <b>File Servers</b>, um fortzufahren.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Zurück',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 124,
                y: 412,
                width: 493,
                height: 35,
              },
              screen: 'reports-tree-screen-sc4-st-2_5',
            },
            {
              tooltip: {
                position: 'left',
                align: 50,
                alignArrow: 50,

                text: '<p>Hier finden Sie Aktivitätsberichte und Statusberichte. Die Aktivitätsberichte geben Aufschluss darüber, was geschehen ist. Die Statusberichte wiederum zeigen die Konfiguration zu einem bestimmten Zeitpunkt.</p> <p>Einen Aktivitätsbericht haben Sie bereits gesehen. Wir zeigen Ihnen nun einen Statusbericht.</p> <p>Klicken Sie auf <b>File Servers – State-in-Time – Folder and File Permission Details</b>, um fortzufahren.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Zurück',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                scrollToView: true,
                x: 124,
                y: 476,
                width: 493,
                height: 35,
              },
              screen: 'reports-tree-screen-sc4-st-2_5',
            },
            {
              tooltip: {
                position: 'left',
                align: 50,
                alignArrow: 50,

                text: '<p>Hier finden Sie Aktivitätsberichte und Statusberichte. Die Aktivitätsberichte geben Aufschluss darüber, was geschehen ist. Die Statusberichte wiederum zeigen die Konfiguration zu einem bestimmten Zeitpunkt.</p> <p>Einen Aktivitätsbericht haben Sie bereits gesehen. Wir zeigen Ihnen nun einen Statusbericht.</p> <p>Klicken Sie auf <b>File Servers – State-in-Time – Folder and File Permission Details</b>, um fortzufahren.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Zurück',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 124,
                y: 667,
                width: 493,
                height: 35,
              },
              screen: 'reports-tree-screen-sc4-st-2_5',
            },
            {
              tooltip: {
                position: 'left',

                text: '<p>Dieser Bericht enthält standardmäßig eine Liste der Zugriffsrechte aller Konten für den Stammordner einer überwachten Freigabe und die Unterordner der ersten Ebene.</p> <p>Blättern Sie durch die Liste und klicken Sie auf <b>Weiter</b>, um Details zu den Zugriffsrechten anzuzeigen.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Zurück',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                  {
                    text: 'Weiter',
                    events: [
                      {
                        type: EVENT_NEXT_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                scrollToView: true,
                x: 124,
                y: 680,
                width: 870,
                height: 780,
              },
              screen: 'preview-report-screen-sc4-st6_10',
            },
            {
              tooltip: {
                width: 370,
                position: 'left',
                align: 30,
                alignArrow: 20,

                text: '<p>Angenommen, in einem Ihrer Ordner sind sehr sensible Daten gespeichert und Sie müssen sicherstellen, dass nur berechtigte Personen darauf zugreifen können.</p><p>Auch hierzu verwenden Sie Filter.</p><p>Klicken Sie auf <b>Weiter</b>, um mit der Konfiguration zu beginnen.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Zurück',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                  {
                    text: 'Weiter',
                    id: 'sc4_st7',
                    events: [
                      {
                        type: EVENT_NEXT_STEP,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'File and Folders Permissions',
                          stage: '50%',
                        },
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                scrollToView: true,
                x: 114,
                y: 100,
                width: 960,
                height: 302,
              },
              screen: 'preview-report-screen-sc4-st6_10',
            },
            {
              tooltip: {
                position: 'left',
                align: -100,
                alignArrow: 15,

                text: '<p>Geben Sie zunächst an, für welchen Ordner Sie die Berechtigungen überprüfen möchten.</p><p>Geben Sie in den Filter <b>Object UNC Path</b> den Pfad <b>\\\\fileserver1\\Shared\\Finance</b> ein.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Zurück',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 594,
                y: 168,
                width: 480,
                height: 35,
              },
              screen: 'preview-report-screen-sc4-st6_10',
            },
            {
              tooltip: {
                position: 'left',
                align: -100,
                alignArrow: 15,

                text: '<p>Legen Sie außerdem fest, dass die Gruppenzugehörigkeit nicht erweitert werden kann. So verringern Sie die Anzahl der Elemente, die überprüft werden müssen, und erhalten einen allgemeinen Überblick über die Zugriffsrechte.</p><p>Wählen Sie im Filter <b>Expand Group</b> Membership die Option <b>No.</b></p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Zurück',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 110,
                y: 300,
                width: 480,
                height: 35,
              },
              screen: 'preview-report-screen-sc4-st6_10',
            },
            {
              tooltip: {
                position: 'leftTRUE',
                align: -65,
                alignArrow: 19,
                width: 395,
                text: '<p>Die Einstellungen sehen gut aus! Führen Sie den Bericht nun aus.</p> <p>Klicken Sie auf <b>View Report</b>, um fortzufahren.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Zurück',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 1438,
                y: 130,
                width: 115,
                height: 50,
              },
              screen: 'preview-report-screen-sc4-st6_10',
            },
            {
              tooltip: {
                position: 'left',
                align: -30,
                alignArrow: 32,

                text: '<p>Wie Sie sehen können, haben eine Gruppe und zwei Benutzer Zugriff auf den Ordner "Finance".</p> <p>Bei der Gruppe handelt es sich um die Gruppe <b>Finance</b>, die selbstverständlich Zugriff auf den Ordner benötigt.</p><p>Doch warum haben die Benutzerkonten <b>T.Smith</b> und <b>J.Roberts</b> direkten und uneingeschränkten Zugriff auf diesen Ordner?</p><p>Klicken Sie auf <b>Weiter</b>, um fortzufahren.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Zurück',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                  {
                    text: 'Weiter',
                    events: [
                      {
                        type: EVENT_NEXT_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                scrollToView: true,
                x: 124,
                y: 680,
                width: 870,
                height: 213,
              },
              screen: 'preview-report-screen-sc4-st11',
            },
            {
              tooltip: {
                position: 'left',
                align: -105,
                alignArrow: 80,

                text: '<p>Offenbar wurden außerdem die Berechtigungen für den Unterordner <b>Accounting</b> falsch vererbt, sodass <b>T.Simpson</b> uneingeschränkten Zugriff auf diesen Ordner hat. Die Berechtigungen wurden direkt erteilt, was klar gegen Best Practices für die Vergabe von Berechtigungen verstößt.</p><p>Klicken Sie auf <b>Weiter</b>, um fortzufahren.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Zurück',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                  {
                    text: 'Weiter',
                    events: [
                      {
                        type: EVENT_NEXT_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 124,
                y: 896,
                width: 870,
                height: 237,
              },
              screen: 'preview-report-screen-sc4-st11',
            },
            {
              tooltip: {
                position: 'left',
                align: -100,
                alignArrow: 17,
                width: 395,
                text: '<p>Gut gemacht! Auch diesen Bericht habe ich Ihnen als Kopie gesendet.</p><p>Klicken Sie auf <b>Zurück</b>, um fortzufahren.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Zurück',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                scrollToView: true,
                x: 116,
                y: 38,
                width: 50,
                height: 38,
              },
              screen: 'preview-report-screen-sc4-st11',
            },
            {
              tooltip: {
                width: 424,
                hideViewArea: true,
                hideArrow: true,

                text: '<p>Gerne zeige ich Ihnen weitere Berichte oder andere hilfreiche Funktionen von Netwrix Auditor. Klicken Sie hierzu einfach auf <b>Tour fortsetzen.</b></p> <p>Wenn Sie eine persönliche Demo mit einem unserer Engineers wünschen, klicken Sie bitte auf <b>Persönliche Demo anfordern.</b></p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Tour fortsetzen',
                    id: 'sc4_st14',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 0,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'File and Folders Permissions',
                          stage: 'Completed',
                        },
                      },
                    ],
                  },
                  {
                    text: 'Persönliche Demo',
                    events: [
                      {
                        type: EVENT_DEMO_LINK,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 1180,
                y: 400,
                width: 1,
                height: 1,
              },
              screen: 'main-screen-x',
            },
          ],
          [
            {
              tooltip: {
                position: 'left',
                align: 50,
                alignArrow: 50,

                text: '<p>Tutti i report (predefiniti e personalizzati) di Netwrix Auditor sono archiviati in un’unica posizione. Vediamo cosa abbiamo.</p><p>Cliccare su <b>View all</b> per continuare.</p>',
                showSteps: true,
                actions: [],
              },
              viewArea: {
                x: 635,
                y: 445,
                width: 73,
                height: 28,
              },
              screen: 'main-screen-x',
            },
            {
              tooltip: {
                position: 'left',
                text: '<p>I report e dashboard sono suddivisi in cartelle di tre livelli: Predefinito, Conformità e Personalizzato.</p> <p>Oggi ci concentreremo sui report pronti all’uso forniti da Netwrix.</p> <p>Cliccare su <b>Avanti</b> per continuare.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Indietro',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                  {
                    text: 'Avanti',
                    events: [
                      {
                        type: EVENT_NEXT_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 124,
                y: 102,
                width: 493,
                height: 631,
              },
              screen: 'reports-tree-screen-sc4-st-2_5',
            },
            {
              tooltip: {
                position: 'left',
                align: 50,
                alignArrow: 50,

                text: '<p>Ho un’ idea. Lascia che ti mostri alcuni report sulle <b>autorizzazioni dei file server</b>. Dopotutto, gli amministratori IT devono sempre lavorare/avere a che fare con i diritti di accesso per preservare la sicurezza e conformità del proprio ambiente.</p> <p>Cliccare su <b>File Server</b> per continuare.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Indietro',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 124,
                y: 412,
                width: 493,
                height: 35,
              },
              screen: 'reports-tree-screen-sc4-st-2_5',
            },
            {
              tooltip: {
                position: 'left',
                align: 50,
                alignArrow: 50,

                text: '<p>Qui abbiamo i report di attività e State-in-Time. I report di attività rispondono alla domanda: cosa è successo? I report state-in-Time, invece, mostrano lo stato della configurazione in un momento specifico nel tempo.</p> <p>Abbiamo già esaminato un report di attività, quindi ora analizzeremo un report State-in-Time.</p> <p>Cliccare su <b>File Server – State-in-Time – Dettagli autorizzazione Cartella e File</b> per continuare.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Indietro',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                scrollToView: true,
                x: 124,
                y: 476,
                width: 493,
                height: 35,
              },
              screen: 'reports-tree-screen-sc4-st-2_5',
            },
            {
              tooltip: {
                position: 'left',
                align: 50,
                alignArrow: 50,

                text: '<p>Qui troviamo i report di attività e State-in-Time. I report di attività rispondono alla domanda: cosa è successo? I report state-in-Time, invece, mostrano lo stato della configurazione in un momento specifico nel tempo.</p> <p>Abbiamo già esaminato un report di attività, quindi ora analizzeremo un report State-in-Time.</p> <p>Cliccare su <b>File Server – State-in-Time – Dettagli autorizzazione Cartella e File</b> per continuare.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Indietro',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 124,
                y: 667,
                width: 493,
                height: 35,
              },
              screen: 'reports-tree-screen-sc4-st-2_5',
            },
            {
              tooltip: {
                position: 'left',

                text: '<p>Per impostazione predefinita, questo report mostra le autorizzazioni di tutti gli account a una condivisione monitorata della cartella principale e delle relative sottocartelle di primo livello.</p> <p>Scorrere e cliccare su <b>Avanti</b> quando sarai pronto ad andare più a fondo.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Indietro',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                  {
                    text: 'Avanti',
                    events: [
                      {
                        type: EVENT_NEXT_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                scrollToView: true,
                x: 124,
                y: 680,
                width: 870,
                height: 780,
              },
              screen: 'preview-report-screen-sc4-st6_10',
            },
            {
              tooltip: {
                width: 370,
                position: 'left',
                align: 30,
                alignArrow: 20,

                text: '<p>Immaginiamo di avere una cartella molto sensibile e dobbiamo assicurarci che solo le persone idonee possano accedervi.</p> <p>Ancora una volta, utilizzeremo i filtri per far sì che ciò accada.</p><p>Clicca su <b>Avanti</b> quando sarai pronto per iniziare.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Indietro',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                  {
                    text: 'Avanti',
                    id: 'sc4_st7',
                    events: [
                      {
                        type: EVENT_NEXT_STEP,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'File and Folders Permissions',
                          stage: '50%',
                        },
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                scrollToView: true,
                x: 114,
                y: 100,
                width: 960,
                height: 302,
              },
              screen: 'preview-report-screen-sc4-st6_10',
            },
            {
              tooltip: {
                position: 'left',
                align: -100,
                alignArrow: 15,

                text: '<p>Per prima cosa, occorre specificare per quale cartella si vogliono controllare le autorizzazioni.</p><p>Digitare <b>\\\\fileserver1\\Shared\\Finance</b> nell’Oggetto filtro Percorso UNC.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Indietro',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 594,
                y: 168,
                width: 480,
                height: 35,
              },
              screen: 'preview-report-screen-sc4-st6_10',
            },
            {
              tooltip: {
                position: 'left',
                align: -100,
                alignArrow: 15,

                text: '<p>Inoltre, meglio non ampliare la membership di un gruppo. Ciò ridurrà il numero di elementi da esaminare e fornirà una prospettiva più ampia delle autorizzazioni di accesso.</p> <p>Selezionare <b>No</b> nel filtro Espandi Membership di gruppo.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Indietro',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 110,
                y: 300,
                width: 480,
                height: 35,
              },
              screen: 'preview-report-screen-sc4-st6_10',
            },
            {
              tooltip: {
                position: 'leftTRUE',
                align: -65,
                alignArrow: 19,
                width: 395,
                text: '<p>Fantastico! Ora eseguiamo il report.</p> <p>Cliccare su <b>Visualizza Report</b> per continuare.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Indietro',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 1438,
                y: 130,
                width: 115,
                height: 50,
              },
              screen: 'preview-report-screen-sc4-st6_10',
            },
            {
              tooltip: {
                position: 'left',
                align: -30,
                alignArrow: 32,

                text: '<p>Come puoi vedere, c’è un gruppo e due utenti che hanno accesso alla cartella Finance.</p> <p>Il gruppo è <b>Finance</b> — fin qui nessun problema.</p><p>Ma perché gli account utente <b>T.Smith</b> e <b>J.Roberts</b> hanno il pieno controllo delle autorizzazioni su questa cartella?</p><p>Cliccare su <b>Avanti</b> per continuare.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Indietro',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                  {
                    text: 'Avanti',
                    events: [
                      {
                        type: EVENT_NEXT_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                scrollToView: true,
                x: 124,
                y: 680,
                width: 870,
                height: 213,
              },
              screen: 'preview-report-screen-sc4-st11',
            },
            {
              tooltip: {
                position: 'left',
                align: -105,
                alignArrow: 80,

                text: '<p>Inoltre, sembra anche che una delle sottocartelle, <b>Accounting</b>, abbia infranto l’eredità delle autorizzazioni— <b>T.Simpson</b> possiede il pieno controllo di questa cartella, che gli è stato concesso in maniera diretta. Si tratta di una evidente violazione delle best practices in materia di assegnazioni delle autorizzazioni.</p><p>Cliccare su <b>Avanti</b> per continuare.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Indietro',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                  {
                    text: 'Avanti',
                    events: [
                      {
                        type: EVENT_NEXT_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 124,
                y: 896,
                width: 870,
                height: 237,
              },
              screen: 'preview-report-screen-sc4-st11',
            },
            {
              tooltip: {
                position: 'left',
                align: -100,
                alignArrow: 17,
                width: 395,
                text: '<p>Ottimo lavoro! Ti ho inviato una copia di questo report.</p><p>Clicca su <b>Indietro</b> quando sei pronto.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Indietro',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                scrollToView: true,
                x: 116,
                y: 38,
                width: 50,
                height: 38,
              },
              screen: 'preview-report-screen-sc4-st11',
            },
            {
              tooltip: {
                width: 424,
                hideViewArea: true,
                hideArrow: true,

                text: '<p>Ma sarò ben felice di mostrarti altri report o cose utili che puoi fare con Netwrix Auditor; basta cliccare su <b>Continua Tour.</b></p> <p>Se invece vuoi realizzare una demo one-on-one con uno dei nostri ingegneri, non mi offenderò affatto! Basta cliccare su <b>Richiedi Demo 1-1.</b></p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Continua Tour',
                    id: 'sc4_st14',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 0,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'File and Folders Permissions',
                          stage: 'Completed',
                        },
                      },
                    ],
                  },
                  {
                    text: 'Richiedi Demo 1-1',
                    events: [
                      {
                        type: EVENT_DEMO_LINK,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 1180,
                y: 400,
                width: 1,
                height: 1,
              },
              screen: 'main-screen-x',
            },
          ],
          [
            {
              tooltip: {
                position: 'left',
                align: 50,
                alignArrow: 50,

                text: '<p>Все предварительно настроенные и настраиваемые отчеты Netwrix Auditor хранятся в одном месте. Давайте посмотрим, что здесь есть.</p> <p>Чтобы продолжить, нажмите <b>View all</b>.</p>',
                showSteps: true,
                actions: [],
              },
              viewArea: {
                x: 635,
                y: 445,
                width: 73,
                height: 28,
              },
              screen: 'main-screen-x',
            },
            {
              tooltip: {
                position: 'left',
                text: '<p>Все отчеты и панели мониторинга разделены на папки верхнего уровня: «Predefined» (предварительно настроенные), «Compliance» (соответствие нормативным требованиям) и «Custom» (настраиваемые).</p> <p>Сегодня мы рассмотрим готовые отчеты, которые поставляются вместе с решением Netwrix.</p> <p>Чтобы продолжить, нажмите кнопку <b>Далее.</b></p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Назад',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                  {
                    text: 'Далее',
                    events: [
                      {
                        type: EVENT_NEXT_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 124,
                y: 102,
                width: 493,
                height: 631,
              },
              screen: 'reports-tree-screen-sc4-st-2_5',
            },
            {
              tooltip: {
                position: 'left',
                align: 50,
                alignArrow: 50,

                text: '<p>Вот что я предлагаю. Давайте посмотрим отчеты по <b>правам доступа к файловому серверу</b>, ведь ИТ-администраторам постоянно приходится работать с правами доступа, чтобы обеспечить безопасность инфраструктуры и соответствие нормативным требованиям.</p> <p>Чтобы продолжить, нажмите <b>File Servers</b> (Файловые серверы).</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Назад',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 124,
                y: 412,
                width: 493,
                height: 35,
              },
              screen: 'reports-tree-screen-sc4-st-2_5',
            },
            {
              tooltip: {
                position: 'left',
                align: 50,
                alignArrow: 50,

                text: '<p>Здесь представлены отчеты об активности и отчеты о состоянии на заданный момент времени. Отчеты об активности отвечают на вопрос «Что случилось». Отчеты о состоянии на заданный момент времени показывают конфигурацию в конкретный момент.</p> <p>Один отчет об активности мы уже видели, давайте теперь создадим отчет о состоянии на заданный момент времени.</p> <p>Чтобы продолжить, нажмите <b>File Servers (Файловые серверы) — State-in-Time (Состояние на заданный момент времени) — Folder and File Permission Details (Сведения о правах доступа к папкам и файлам).</b></p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Назад',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                scrollToView: true,
                x: 124,
                y: 476,
                width: 493,
                height: 35,
              },
              screen: 'reports-tree-screen-sc4-st-2_5',
            },
            {
              tooltip: {
                position: 'left',
                align: 50,
                alignArrow: 50,

                text: '<p>Здесь представлены отчеты об активности и отчеты о состоянии на заданный момент времени. Отчеты об активности отвечают на вопрос «Что случилось». Отчеты о состоянии на заданный момент времени показывают состояние конфигурации в конкретный момент.</p> <p>Один отчет об активности мы уже видели, давайте теперь создадим отчет о состоянии на заданный момент времени.</p> <p>Чтобы продолжить, нажмите <b>File Servers — State-in-Time (Файловые серверы - Состояние на заданный момент времени) — Folder and File Permission Details (Сведения о правах доступа к папкам и файлам).</b></p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Назад',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 124,
                y: 667,
                width: 493,
                height: 35,
              },
              screen: 'reports-tree-screen-sc4-st-2_5',
            },
            {
              tooltip: {
                position: 'left',

                text: '<p>По умолчанию этот отчет показывает для всех учетных записей права доступа к корневой папке контролируемого ресурса и папкам первого уровня.</p> <p>Изучите содержимое окна и нажмите <b>Далее</b>, когда будете готовы продолжить.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Назад',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                  {
                    text: 'Далее',
                    events: [
                      {
                        type: EVENT_NEXT_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                scrollToView: true,
                x: 124,
                y: 680,
                width: 870,
                height: 780,
              },
              screen: 'preview-report-screen-sc4-st6_10',
            },
            {
              tooltip: {
                width: 370,
                position: 'left',
                align: 30,
                alignArrow: 20,

                text: '<p>Давайте представим себе, что у нас есть очень конфиденциальная папка, и нужно убедиться, что доступ к ней имеет только ограниченный круг лиц.</p> <p>Для этого мы снова используем фильтры.</p><p>Когда будете готовы, нажмите <b>Далее</b>.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Назад',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                  {
                    text: 'Далее',
                    id: 'sc4_st7',
                    events: [
                      {
                        type: EVENT_NEXT_STEP,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'File and Folders Permissions',
                          stage: '50%',
                        },
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                scrollToView: true,
                x: 114,
                y: 100,
                width: 960,
                height: 302,
              },
              screen: 'preview-report-screen-sc4-st6_10',
            },
            {
              tooltip: {
                position: 'left',
                align: -100,
                alignArrow: 15,

                text: '<p>Сначала надо указать папку, права доступа к которой надо проверить.</p><p>Введите <b>\\\\fileserver1\\Shared\\Finance</b> в поле «Object UNC Path» (UNC-путь к объекту).</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Назад',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 594,
                y: 168,
                width: 480,
                height: 35,
              },
              screen: 'preview-report-screen-sc4-st6_10',
            },
            {
              tooltip: {
                position: 'left',
                align: -100,
                alignArrow: 15,

                text: '<p>Расширять состав групп мы не будем: это позволит сократить объем отслеживаемых данных и получить более общую картину прав доступа.</p><p>Выберите <b>No</b> в поле «Expand Group Membership» (Расширить состав групп).</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Назад',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 110,
                y: 300,
                width: 480,
                height: 35,
              },
              screen: 'preview-report-screen-sc4-st6_10',
            },
            {
              tooltip: {
                position: 'leftTRUE',
                align: -65,
                alignArrow: 19,
                width: 395,
                text: '<p>Замечательно! Теперь давайте создадим отчет.</p> <p>Чтобы продолжить, нажмите <b>View Report</b> (Посмотреть отчет).</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Назад',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 1438,
                y: 130,
                width: 115,
                height: 50,
              },
              screen: 'preview-report-screen-sc4-st6_10',
            },
            {
              tooltip: {
                position: 'left',
                align: -30,
                alignArrow: 32,

                text: '<p>Как видите, доступ к папке «Finance» (Финансы) имеет одна группа и два пользователя.</p> <p>Группа <b>Finance</b> — это понятно.</p><p>А вот почему полные права доступа к папке предоставлены учетным записям <b>T.Smith</b> и <b>J.Roberts</b> — в этом надо разобраться.</p><p>Чтобы продолжить, нажмите кнопку <b>Далее</b>.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Назад',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                  {
                    text: 'Далее',
                    events: [
                      {
                        type: EVENT_NEXT_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                scrollToView: true,
                x: 124,
                y: 680,
                width: 870,
                height: 213,
              },
              screen: 'preview-report-screen-sc4-st11',
            },
            {
              tooltip: {
                position: 'left',
                align: -105,
                alignArrow: 80,

                text: '<p>Кроме того, похоже, что у одной из подпапок — Accounting (Бухгалтерия) — проблема с наследованием разрешений: учетная запись T.Simpson имеет полные права доступа к этой папке, причем права были предоставлены напрямую. Это очевидное нарушение рекомендаций по предоставлению прав.</p><p>Когда закончите, нажмите <b>Далее</b>.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Назад',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                  {
                    text: 'Далее',
                    events: [
                      {
                        type: EVENT_NEXT_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 124,
                y: 896,
                width: 870,
                height: 237,
              },
              screen: 'preview-report-screen-sc4-st11',
            },
            {
              tooltip: {
                position: 'left',
                align: -100,
                alignArrow: 17,
                width: 395,
                text: '<p>Прекрасно! Я отправил вам копию этого отчета.</p><p>Когда закончите, нажмите стрелку <b>Назад</b>.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Назад',
                    events: [
                      {
                        type: EVENT_PREV_STEP,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                scrollToView: true,
                x: 116,
                y: 38,
                width: 50,
                height: 38,
              },
              screen: 'preview-report-screen-sc4-st11',
            },
            {
              tooltip: {
                width: 544,
                hideViewArea: true,
                hideArrow: true,

                text: '<p>С этим сценарием мы закончили. С удовольствием покажу вам другие полезные вещи, которые можно сделать с помощью Netwrix Auditor: просто нажмите <b>Продолжить обзор</b>.</p> <p>Но если вы хотите договориться с нашими инженерами о персональном демо, я не обижусь! Для этого нажмите <b>Запросить персональное демо</b>.</p>',
                showSteps: true,
                actions: [
                  {
                    text: 'Продолжить обзор',
                    id: 'sc4_st14',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 0,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'File and Folders Permissions',
                          stage: 'Completed',
                        },
                      },
                    ],
                  },
                  {
                    text: 'Запросить персональное демо',
                    events: [
                      {
                        type: EVENT_DEMO_LINK,
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 1180,
                y: 400,
                width: 1,
                height: 1,
              },
              screen: 'main-screen-x',
            },
          ],
        ],
      }
    },
    computed: {
      ...mapState('guide', ['currentScreen']),
      language() {
        return this.$store.state.guide.lang;
      },
    },
    methods: {
      ...mapActions('guide', ['setSteps']),
    },
    created() {
      this.setSteps(this.steps[this.language]);
    },
  }
</script>

<style scoped>

</style>